export default __webpack_public_path__ + "static/media/pencil2.360ffbb1.svg";